module.exports = __webpack_public_path__ + "img/traditional_crackers.07dbc876.png";